import React from "react"
import styled from "styled-components"
import Helmet from "react-helmet"
import { MuiThemeProvider } from "@material-ui/core/styles"
import "minireset.css"

import Edges from "../../components/_layout/edges"

// import app components
import Header from "../../components/header"
import Footer from "../../components/footer"

// import others
import { mui } from "../../theme"

import * as theme from "../../theme"

const Layout = props => {
  return (
    <MuiThemeProvider theme={mui}>
      <AppWrapper>
        <Helmet>
          <meta name="description" />
        </Helmet>
        <Edges size="lg">
          <Header path={props.location.pathname} />
          <Page>{props.children}</Page>
          <Footer />
        </Edges>
      </AppWrapper>
    </MuiThemeProvider>
  )
}

const Page = styled.div`
  position: relative;
  min-height: calc(100vh - 490px);
  border-radius: 0 0 10px 10px;
  background: ${theme.color.paper};
  z-index: 10;
`
const AppWrapper = styled.div`
  background: ${theme.color.background};
`

export default Layout
